/**
 * @file actions/Personalization/library.js
 * @copyright 2018 CBC/Radio-Canada. All rights reserved.
 * @author Joey Yip [joey.yip@cbc.ca]
 */
import {
    RECOMMENDED_FOR_YOU_AB_TESTS_KEY,
    REC_FOR_YOU_DEFAULT_ALGORITHM_ID,
} from "./constants";
import { getABTestsConfig } from "../Page/utils";
import { getSelection } from "../../hooks/useABTest/utils";

/**
 * Returns the string id for the Recommended For You algorithm that will
 * be supplied to personalizedItems GQL query. If the user is part of an A/B test
 * it will obtain the string from the ABTESTSCONFIG tests, otherwise it will use
 * the default algorithm.
 *
 * @returns {string} algorithmId
 */
export async function getPersonalizedItemsAlgorithmId() {
    const abTests = await getABTestsConfig();

    if (!abTests?.[RECOMMENDED_FOR_YOU_AB_TESTS_KEY])
        return REC_FOR_YOU_DEFAULT_ALGORITHM_ID;

    const selection = await getSelection(
        abTests[RECOMMENDED_FOR_YOU_AB_TESTS_KEY].id
    );
    const variant =
        abTests[RECOMMENDED_FOR_YOU_AB_TESTS_KEY].variants[selection];

    if (!variant) return REC_FOR_YOU_DEFAULT_ALGORITHM_ID;

    return variant.algorithmId;
}
